module.exports = __webpack_public_path__ + "img/1.6964a7b3.jpg";